module.exports = __webpack_public_path__ + "img/pexels-breston-kenya-3299174.2d59dcce.jpg";